module.exports = __webpack_public_path__ + "static/img/Code-Space-Design.6323bc14.jpg";